import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { TextContainer } from '../../styles/globalStyles'
import { b, v } from '../../styles/variables'
import {Link, useNavigate} from 'react-router-dom'
import {Location} from '@styled-icons/evil/Location'
import {FoodTag} from '@styled-icons/boxicons-regular/FoodTag'
import {KeyboardArrowRight} from '@styled-icons/material-sharp/KeyboardArrowRight';

function getVendorImage(vendorImage) {
  if (!vendorImage) return null;
  try {
    const img = require("../../" + vendorImage);
    return img.default || img;
  } catch {
    return null;
  }
}

function VendorCard({vendor}) {
 const navigate = useNavigate()
 const imgpath = getVendorImage(vendor.vendor_image)

  return (
    <CardContainer onClick={()=>navigate(`/fooddata/foodbyvendor/${vendor.vendor_id}`)}>
      {imgpath ? (
        <ImgContainer>  
          <VendorImg src={imgpath} alt={vendor.vendor_name} onError={(e) => { e.target.style.display = 'none'; }}/>    
          <FoodTypeTag>
            <FoodTag size={16} color="#fff"/>
            <span>{vendor.vendor_type === "2" ? "Veg & Non-Veg" : "Vegetarian"}</span>
          </FoodTypeTag>
        </ImgContainer>
      ) : (
        <PlaceholderImg>
          <FoodTag size={32} color="#d4d4d8"/>
          <FoodTypeTag>
            <FoodTag size={16} color="#fff"/>
            <span>{vendor.vendor_type === "2" ? "Veg & Non-Veg" : "Vegetarian"}</span>
          </FoodTypeTag>
        </PlaceholderImg>
      )}
      <CardBody>
        <VendorName>{vendor.vendor_name}</VendorName>
        <LocationRow>
          <Location size={20} color="#71717a"/>
          <LocationText>{vendor.vendor_location}</LocationText>
        </LocationRow>
      </CardBody>
      <CardFooter>
        <ViewMenuText>View Menu</ViewMenuText>
        <ArrowIcon size={20} />
      </CardFooter>
    </CardContainer>
  )
}

export default VendorCard

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #f4f4f5;
  cursor: pointer;
  transition: all 0.25s ease;
  -webkit-tap-highlight-color: transparent;

  &:hover, &:active {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
    border-color: transparent;
  }

  &:active {
    transform: translateY(-2px);
  }
`;

const ImgContainer = styled.div`
  position: relative;
  height: 150px;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 16px 16px 0 0;
`

const PlaceholderImg = styled.div`
  position: relative;
  height: 150px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f8fa 0%, #eef0f5 100%);
  border-radius: 16px 16px 0 0;
`

const VendorImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  
  ${CardContainer}:hover & {
    transform: scale(1.05);
  }
`;

const FoodTypeTag = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  color: #fff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 1.1rem;
  font-weight: 500;
`

const CardBody = styled.div`
  padding: 1.4rem 1.6rem 0.8rem;
`

const VendorName = styled.h3`
  font-size: 1.7rem;
  font-weight: 700;
  color: #1e1e2d;
  margin-bottom: 0.6rem;
  overflow-wrap: break-word;
  word-break: break-word;
`

const LocationRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const LocationText = styled.span`
  font-size: 1.3rem;
  color: #71717a;
  font-weight: 400;
  overflow-wrap: break-word;
  word-break: break-word;
`

const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.6rem 1.4rem;
  margin-top: auto;
`

const ViewMenuText = styled.span`
  font-size: 1.3rem;
  font-weight: 600;
  color: #F7707D;
`

const ArrowIcon = styled(KeyboardArrowRight)`
  color: #F7707D;
  transition: transform 0.2s ease;
  
  ${CardContainer}:hover & {
    transform: translateX(4px);
  }
`
